import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';

export function paintNebulaTag(el, cluster) {
  if (el.dataset.editing === '1') return;
  el.dataset.clusterKey = cluster.key;
  el.textContent = cluster.key;
  el.style.setProperty('--nebula-tint', cluster.tint);
  el.title = 'Click to rename tag';
}

function beginNebulaRename(el, rename) {
  const oldName = el.dataset.clusterKey;
  if (!oldName || !rename || el.dataset.editing === '1') return;
  el.dataset.editing = '1';
  el.classList.add('neural-view__nebula-tag--editing');
  const input = document.createElement('textarea');
  input.rows = 2;
  input.className = 'neural-view__nebula-tag-input';
  input.value = oldName;
  input.setAttribute('aria-label', `Rename tag ${oldName}`);
  el.textContent = '';
  el.appendChild(input);
  input.focus();
  input.select();
  let done = false;
  const finish = (save) => {
    if (done) return;
    done = true;
    document.removeEventListener('pointerdown', onDocDown, true);
    const next = input.value.replace(/\s+/g, ' ').trim();
    el.dataset.editing = '';
    el.classList.remove('neural-view__nebula-tag--editing');
    input.remove();
    const keep = save && next && next !== oldName;
    if (keep) {
      el.dataset.clusterKey = next;
      el.textContent = next;
      rename(oldName, next);
    } else {
      el.textContent = oldName;
    }
  };
  const onDocDown = (e) => {
    if (el.contains(e.target)) return;
    finish(true);
  };
  input.addEventListener('keydown', (e) => {
    e.stopPropagation();
    if (e.key === 'Enter') { e.preventDefault(); finish(true); }
    if (e.key === 'Escape') { e.preventDefault(); finish(false); }
  });
  input.addEventListener('pointerdown', (e) => e.stopPropagation());
  input.addEventListener('click', (e) => e.stopPropagation());
  window.setTimeout(() => document.addEventListener('pointerdown', onDocDown, true), 0);
}

function bindNebulaRename(el, renameTagRef) {
  if (el.dataset.bound === '1') return;
  el.dataset.bound = '1';
  el.addEventListener('pointerdown', (e) => e.stopPropagation());
  el.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    beginNebulaRename(el, renameTagRef?.current);
  });
}

export function makeNebulaTag(cluster, renameTagRef) {
  const el = document.createElement('div');
  el.className = 'neural-view__nebula-tag';
  paintNebulaTag(el, cluster);
  bindNebulaRename(el, renameTagRef);
  const label = new CSS2DObject(el);
  label.center.set(0.5, 1);
  label.userData.isNebulaTag = true;
  return label;
}
